import { DEFAULT_ECOMMERCE_PERIOD } from './ecommerce.helpers';

const emptyAsyncListState = {
  data: [],
  loading: false,
  error: null,
};

const emptyPagedListState = {
  ...emptyAsyncListState,
  page: 0,
  total: null,
  hasMore: false,
  query: '',
};

export const ecommerceInitialState = {
  period: DEFAULT_ECOMMERCE_PERIOD,
  brandDetails: {
    data: null,
    loading: false,
    error: null,
  },
  brandHealth: {
    data: null,
    loading: false,
    error: null,
  },
  productTrend: {
    data: null,
    loading: false,
    error: null,
  },
  userSatisfaction: {
    data: null,
    loading: false,
    error: null,
  },
  riskMonitor: {
    data: null,
    loading: false,
    error: null,
  },
  reviewShare: {
    data: null,
    loading: false,
    error: null,
  },
  productPerformance: {
    data: null,
    loading: false,
    error: null,
  },
  latestReviews: {
    data: [],
    loading: false,
    error: null,
  },
  reviewShareByCategory: {
    data: null,
    loading: false,
    error: null,
  },
  reviewsTable: {
    data: [],
    total: null,
    countLoading: false,
    loading: false,
    hasFetched: false,
    error: null,
    page: 1,
    q: '',
    timeDuration: '1w',
    from: null,
    to: null,
    sort: 'time',
    sortType: 'desc',
    appliedFilters: {},
    seedBrandCode: null,
    seedBrandCodes: [],
  },
  assignedBrands: {
    ...emptyAsyncListState,
  },
  reviewFilterOptions: {
    brands: { ...emptyPagedListState },
    categories: { ...emptyPagedListState },
    products: { ...emptyPagedListState },
    sellers: { ...emptyPagedListState },
  },
};
